module.exports = __webpack_public_path__ + "img/670x290-BG-2.8bfae1a6.png";